export default "__VITE_ASSET__JOX7fyfA__"